<template>
  <div :class="{'file-upload-dialog': true, 'show': dialogVisible}" v-dialogDrag2>
    <div class="file-upload-body">
      <div class="file-dialog-header">
        <span class="dialog-title">文件上传</span>
        <button class="dialog-close" type="button" @click="handleClose">
          <i class="el-icon el-icon-close"></i>
        </button>
      </div>
      <div class="file-dialog-main">
        <el-table
          :data="fileList"
          max-height="350"
          style="width: 100%">
          <el-table-column
            prop="name"
            label="文件名"
            min-width="140">
          </el-table-column>
          <el-table-column
            prop="size"
            label="大小"
            align="center"
            min-width="60">
            <template slot-scope="scope">
            {{(scope.row.size / (1024 * 1024)).toFixed(2)}}M
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="类型">
            <template slot-scope="scope">
            {{scope.row.raw ? scope.row.raw.type : ''}}
            </template>
          </el-table-column>
          <el-table-column
            prop="progress"
            align="center"
            label="进度">
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            min-width="80">
            <template slot-scope="scope">
              <el-button v-if="!scope.row.done && !scope.row.loaded" type="text" @click="checkFile(scope.row)">上传</el-button>
              <el-button v-if="!scope.row.done && scope.row.loaded" type="text" @click="handleUploadCancel(scope.row)">取消</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
// import { adminUpdate } from '@/api/admin'
import axios from 'axios'
import bus from '@/components/common/bus'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => {return {}}
    }
  },
  data() {
    return {
      dialogVisible: false,
      fileList: []
    }
  },
  created() {
    bus.$on('file-upload', file => {
      this.dialogVisible = true
      this.handleAddFile(file)
    })
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    },
    // 添加文件
    handleAddFile(file) {
      this.fileList.push(file)
      this.checkFile(file)
    },
    // 上传前校验
    checkFile(file) {
      let ccInfo = file.ccInfo
      let params = {
        uid: ccInfo.userid,
        ccvid: ccInfo.videoid,
        filename: file.name,
        filesize: file.size,
        servicetype: ccInfo.servicetype
      }
      let url = ccInfo.metaurl
      url = url.replace('http://', 'https://')
      axios({
        url: url,
        method: 'get',
        json: true,
        timeout: 30 * 1000,
        params: params
      }).then(res => {
        if (res.data.result === 0) {
          this.chunkFile(res.data, file, ccInfo)
        } else if (res.data.result === 1) {

        }  else if (res.data.result === -1) {

        }
      }).catch(error => {
        console.log('err: ', error)
      })
    },
    // 切片上传
    chunkFile(data, file, ccInfo) {
      if (data.received < 0) { return }
      let raw = file.raw
      let fm = new FormData()
      let ub = data.received
      let blob = raw.slice(ub, ub + 1024 * 1024 * 2)
      let contentRange = 'bytes ' + ub + '-' + (ub + blob.size - 1) + '/' + file.size
      fm.append('file', blob)

      const cancelToken = axios.CancelToken.source()
      file.cancelToken = cancelToken

      file.loaded = true
      let index = this.fileList.findIndex(item => item.uid === file.uid)
      if (index !== -1) {
        this.$set(this.fileList, index, file)
      }
      let url = ccInfo.chunkurl
      url = url.replace('http://', 'https://')
      axios({
        url: url + `?ccvid=${ccInfo.videoid}`,
        method: 'post',
        json: true,
        timeout: 30 * 1000,
        headers: {
          'Content-Range': contentRange,
          'Content-Disposition': `attachment; filename="${encodeURI(file.name)}"`
        },
        onUploadProgress: progressEvent => {
            var complete = ((data.received + progressEvent.loaded) / file.size * 100 | 0) + '%'
            file.progress = complete
        },
        cancelToken: cancelToken.token,
        data: fm
      }).then(res => {
        if (res.data.result === 0) {
          this.checkFile(file)
        } else if (res.data.result === 1) {
          file.loaded = false
          file.done = true
          let index = this.fileList.findIndex(item => item.uid === file.uid)
          if (index !== -1) {
            this.$set(this.fileList, index, file)
          }
        }  else if (res.data.result === -1) {

        }
      }).catch(error => {
        console.log('err: ', error)
      })
    },
    handleUploadCancel(row) {
      if (row.cancelToken) {
        row.cancelToken.cancel('取消上传')
        row.loaded = false
        row.done = false

        let index = this.fileList.findIndex(item => item.uid === row.uid)
        if (index !== -1) {
          this.$set(this.fileList, index, row)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .file-upload-dialog {
    position: fixed;
    z-index: 9999999;
    right: 0;
    bottom: 0;
    overflow: auto;
    margin: 0;
    width: 480px;
    height: 400px;
    background: #fff;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    display: none;

    &.show {
      display: block;
    }

    .file-upload-body {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    .file-dialog-header {
      padding: 15px 15px 10px;
      // border-bottom: 1px solid #ccc;

      .dialog-title {
        line-height: 24px;
        font-size: 18px;
        color: #303133;
      }

      .dialog-close {
        position: absolute;
        top: 20px;
        right: 20px;
        padding: 0;
        background: 0 0;
        border: none;
        outline: 0;
        cursor: pointer;
        font-size: 16px;
      }
    }

    .file-dialog-main {
      flex: 1;
    }
    .uploader-wrap {
      height: 100%;
    }
    .file-list {
      max-height: 300px;
      overflow: auto;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
</style>
